import React from 'react';
import Row from 'reactstrap/lib/Row';
import Col from 'reactstrap/lib/Col';
import { CmsEntities } from 'client/data/models/cms';
import { MediaContactsCard } from 'site-modules/editorial/components/press/media-contacts-card/media-contacts-card';

import './media-contacts-module.scss';

export function MediaContactsModule({ entry }) {
  const cards = entry.children();

  if (!cards.length) {
    return null;
  }

  return (
    <section className="media-contacts-module py-2" aria-labelledby="media-contacts-heading">
      <h2 id="media-contacts-heading" className="size-36 fw-bold mb-1_5 text-gray-darker">
        {entry.title}
      </h2>
      <Row>
        {cards.map(card => (
          <Col key={card.id} xs={12} sm={6} lg={3} className="mb-1_5">
            <MediaContactsCard entry={card} />
          </Col>
        ))}
      </Row>
    </section>
  );
}

MediaContactsModule.propTypes = {
  entry: CmsEntities.Content.isRequired,
};
